module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("主控设备管理")]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    attrs: {
      "inline": "",
      "model": _vm.formParam
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "校区名称"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择校区",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.changeSchool
    },
    model: {
      value: (_vm.formParam.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.formParam, "schoolId", $$v)
      },
      expression: "formParam.schoolId"
    }
  }, _vm._l((_vm.schoolOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.rootUnid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "序列号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入序列号",
      "clearable": "",
      "maxlength": 100
    },
    model: {
      value: (_vm.formParam.sn),
      callback: function($$v) {
        _vm.$set(_vm.formParam, "sn", $$v)
      },
      expression: "formParam.sn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入设备名称",
      "clearable": "",
      "maxlength": 100
    },
    model: {
      value: (_vm.formParam.name),
      callback: function($$v) {
        _vm.$set(_vm.formParam, "name", $$v)
      },
      expression: "formParam.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择类型",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formParam.type),
      callback: function($$v) {
        _vm.$set(_vm.formParam, "type", $$v)
      },
      expression: "formParam.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.typeOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否配置主控"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.formParam.hasMasterDevice),
      callback: function($$v) {
        _vm.$set(_vm.formParam, "hasMasterDevice", $$v)
      },
      expression: "formParam.hasMasterDevice"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickQuery
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "initial-state"
  }, [(_vm.settingInfo.masterDeviceSwitch) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.clickCloseControl
    }
  }, [_vm._v("关闭主控设置")]) : _c('div', {
    staticClass: "status-box"
  }, [_c('div', {
    staticClass: "status-title"
  }, [_vm._v("当前学校未开启\"主控机器\"功能")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickOpenControl
    }
  }, [_vm._v("开启主控设置")])], 1), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), (_vm.settingInfo.masterDeviceSwitch) ? _c('div', {
    staticClass: "content-wrapper margin-top-20 margin-bottom-20"
  }, [_c('table', {
    staticClass: "custom-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataList), function(row, index) {
    return _c('tr', {
      key: index
    }, [(_vm.handleSpanMethod({
      row: row,
      column: null,
      rowIndex: index,
      columnIndex: 0
    }).rowspan) ? _c('td', {
      attrs: {
        "rowspan": _vm.handleSpanMethod({
          row: row,
          column: null,
          rowIndex: index,
          columnIndex: 0
        }).rowspan
      }
    }, [_vm._v("\n                  " + _vm._s(row.sn) + "\n               ")]) : _vm._e(), _vm._v(" "), (_vm.handleSpanMethod({
      row: row,
      column: null,
      rowIndex: index,
      columnIndex: 1
    }).rowspan) ? _c('td', {
      attrs: {
        "rowspan": _vm.handleSpanMethod({
          row: row,
          column: null,
          rowIndex: index,
          columnIndex: 1
        }).rowspan
      }
    }, [_vm._v("\n                  " + _vm._s(((row.name) + "（" + (_vm.getDeviceTypeName(row.type)) + "）")) + "\n                  "), (row.isMasterDevice) ? _c('span', {
      staticClass: "label-controlled"
    }, [_vm._v("主控")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(((row.externalDeviceName) + "（" + (row.externalDeviceType) + "）")))]), _vm._v(" "), (_vm.handleSpanMethod({
      row: row,
      column: null,
      rowIndex: index,
      columnIndex: 3
    }).rowspan) ? _c('td', {
      attrs: {
        "rowspan": _vm.handleSpanMethod({
          row: row,
          column: null,
          rowIndex: index,
          columnIndex: 3
        }).rowspan
      }
    }, [_c('button', {
      staticClass: "text-button",
      class: {
        'button-uncontrol': !_vm.hasMasterDevice(row)
      },
      on: {
        "click": function($event) {
          return _vm.clickEdit(row)
        }
      }
    }, [_vm._v("\n                     " + _vm._s(_vm.handleMasterDevice(row)) + "\n                  ")])]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请选择主控设备",
      "size": "tiny",
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "destroy-on-close": ""
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.editParam.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickEditDone
          }
        }, [_vm._v("确定")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.editParam.visible),
      callback: function($$v) {
        _vm.$set(_vm.editParam, "visible", $$v)
      },
      expression: "editParam.visible"
    }
  }, [_c('el-radio-group', {
    staticClass: "flex-row gap-10",
    model: {
      value: (_vm.editParam.selectedDevice),
      callback: function($$v) {
        _vm.$set(_vm.editParam, "selectedDevice", $$v)
      },
      expression: "editParam.selectedDevice"
    }
  }, _vm._l((_vm.editParam.deviceList), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": item.uid
      }
    }, [_vm._v("\n            " + _vm._s(item.name + '(' + _vm.getDeviceTypeName(item.type) + ')') + "\n         ")])
  }), 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-box"
  }, [_c('div', {
    staticClass: "tip-line"
  }), _vm._v(" "), _c('span', {
    staticClass: "tips-text"
  }, [_vm._v("本列表用于查看/管理外接筒机、超脑的主控机器，主控机器主要用于对设备进行“人脸同步/更新”操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("设备序列号")]), _vm._v(" "), _c('th', [_vm._v("已绑设备信息")]), _vm._v(" "), _c('th', [_vm._v("设备名称（设备类型）")]), _vm._v(" "), _c('th', [_vm._v("主控设备")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb8a2c12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/EquipmentManage/MasterDevice/MasterDevice.vue
// module id = 1127
// module chunks = 0